/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MovementMove } from './movementMove';
import { MovementStill } from './movementStill';


export interface MovementPostPayloadMovementsInner { 
    DeviceId: string;
    Timestamp: string;
    SensorType: MovementPostPayloadMovementsInner.SensorTypeEnum;
    Event: MovementPostPayloadMovementsInner.EventEnum;
    Direction: number;
    Speed: number;
    EntryDirection: number;
    ExitDirection: number;
}
export namespace MovementPostPayloadMovementsInner {
    export const SensorTypeEnum = {
        G: 'G',
        T: 'T',
        P: 'P'
    } as const;
    export type SensorTypeEnum = typeof SensorTypeEnum[keyof typeof SensorTypeEnum];
    export const EventEnum = {
        NUMBER_1: 1
    } as const;
    export type EventEnum = typeof EventEnum[keyof typeof EventEnum];
}


